<template>
  <span
    :class="`text-secondary ${wordCountNum > wordLimitNum ? 'text-danger' : ''} word-count-text`"
    v-if="wordLimitActive">{{ wordCount + "/" + wordLimit }}</span>
</template>

<style scoped>
.word-count-text {
  position: absolute;
  top: 100%;
  right: 0;
  font-size: 0.85rem;
}
</style>

<script>
export default {
  props: {
    wordCount: {
      type: Number,
      default: 0,
    },
    wordLimit: {
      type: Number | String,
      default: 100,
    },
    wordLimitActive: Boolean
  },
  computed: {
    wordCountNum() {
      return parseInt(this.wordCount ?? 0)
    },
    wordLimitNum() {
      return parseInt(this.wordLimit ?? 0)
    }
  }
}
</script>
